import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { FC, useEffect } from "react";
import { capitalizeFirstLetter, getCookie } from "../../../utils/Utility";
import { getAgents } from "./AgentDetailsAction";
import AgentDetailsStyles from "./AgentDetailsStyles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

const AgentDetailsCard: FC = () => {
  const dispatch = useAppDispatch();
  const customerId = getCookie("id");
  const carrier = getCookie("carrier");
  const system = getCookie("system");

  const { agentDetails } = useAppSelector((state) => state.agentDetails);
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:600px)");
  useEffect(() => {
    if (customerId === "0987") {
      return;
    }

    if (customerId && carrier && system) {
      dispatch(
        getAgents({
          customerId,
          carrier,
          system,
        })
      );
    }
  }, [customerId, carrier, system]);
  if (!agentDetails || !agentDetails?.length) return null;
  return (
    <>
      {agentDetails && agentDetails?.length && (
        <Box
          id="agentdetails_container"
          data-test-id="test-agentdetails_container"
          aria-label="Agent Details Container"
        >
          <Typography 
            id="agentdetails_heading"
            data-test-id="test-agentdetails_heading"
            aria-label="My Agents Heading"
            sx={AgentDetailsStyles.agentHeading}
          >
            {t("My Agents")}
          </Typography>
          <Box
            id="agentdetails_agents-box"
            data-test-id="test-agentdetails_agents-box"
            aria-label="Agents List"
            sx={{
              ...AgentDetailsStyles.agentBoxStyles,
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            {agentDetails?.map((agent) => (
              <Card 
                id={`agentdetails_agent-card-${agent?.emailInfo}`}
                data-test-id={`test-agentdetails_agent-card-${agent?.emailInfo}`}
                aria-label="Agent Information Card"
                sx={AgentDetailsStyles.agentsCard} 
                key={agent?.emailInfo}
              >
                <Typography 
                  id={`agentdetails_agent-name-${agent?.emailInfo}`}
                  data-test-id={`test-agentdetails_agent-name-${agent?.emailInfo}`}
                  aria-label="Agent Name"
                  sx={AgentDetailsStyles.agentContent}
                >
                  <Tooltip 
                    id={`agentdetails_agent-name-tooltip-${agent?.emailInfo}`}
                    data-test-id={`test-agentdetails_agent-name-tooltip-${agent?.emailInfo}`}
                    aria-label="Agent Name Tooltip"
                    title={agent?.nameInfo?.toLowerCase()}
                  >
                    <Typography 
                      id={`agentdetails_agent-name-value-${agent?.emailInfo}`}
                      data-test-id={`test-agentdetails_agent-name-value-${agent?.emailInfo}`}
                      aria-label="Agent Name Value"
                      sx={AgentDetailsStyles.agentInnerContent}
                    >
                      <strong>{t("Name")} : </strong>{" "}
                      {capitalizeFirstLetter(agent?.nameInfo || "")}
                    </Typography>
                  </Tooltip>
                </Typography>
                <Tooltip 
                  id={`agentdetails_agent-email-tooltip-${agent?.emailInfo}`}
                  data-test-id={`test-agentdetails_agent-email-tooltip-${agent?.emailInfo}`}
                  aria-label="Agent Email Tooltip"
                  title={agent?.emailInfo?.toLowerCase()}
                >
                  <Typography 
                    id={`agentdetails_agent-email-${agent?.emailInfo}`}
                    data-test-id={`test-agentdetails_agent-email-${agent?.emailInfo}`}
                    aria-label="Agent Email"
                    sx={AgentDetailsStyles.agentInnerContent}
                  >
                    <strong>{t("Email")} : </strong>{" "}
                    {agent?.emailInfo?.toLowerCase() || ""}
                  </Typography>
                </Tooltip>
                <Typography 
                  id={`agentdetails_agent-contact-${agent?.emailInfo}`}
                  data-test-id={`test-agentdetails_agent-contact-${agent?.emailInfo}`}
                  aria-label="Agent Contact"
                  sx={AgentDetailsStyles.agentInnerContent}
                >
                  <strong>{t("Contact")} : </strong>
                  {agent?.phoneInfo?.replace(/[-()\s]/g, "")}
                </Typography>
              </Card>
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};

export default AgentDetailsCard;
